import { BulkCancelSpacecontrolBookingDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

export const useCancelSpaceBooking: OneCreationActionResolver = () => {
  const [cancelBooking, { loading }] = useMutation(BulkCancelSpacecontrolBookingDocument, {
    extractorFn: (data) => data.spaceControlMutations.bulkCancelSpacecontrolBooking,
    errorPolicy: 'all',
  })

  const cancelBookingHandler = async (args: { ids: string[] }) => {
    const result = await cancelBooking({
      variables: {
        ids: args.ids,
      },
    })

    return handleResult(result, (_errors) => {})
  }

  return {
    resolver: cancelBookingHandler,
    loading,
  }
}
